import React from 'react';
import styles from './styles/XHStack.module.scss';
// import X from './XModule';

export interface IHStackProps {
    children? :React.ReactNode;
    height?: string;
    width?: string;
    //name:string;
    //optionalParam?:number;
}
export interface IHStackState {

}
export class XHStack extends React.Component<IHStackProps, IHStackState>/*<Props, State>*/ {
    // constructor(props: IHStackProps) {
    //     super(props)
    // }
    render() :React.ReactNode
    {
        return (
            <div className={styles.XHStack} style={{width: this.props.width, height: this.props.height}}>
                    {this.props.children}
            </div>
        );
    }
}